<div class="ui-textarea" :class="[state.errorStyle, state.disableStyle, styleClass]">
  <textarea  :name="privateId" :disabled="isDisable" :id="privateId" cols="30" rows="10" :maxlength="maxlength"
    :value="value" @input="privateValue = $event.target.value"
    :tabindex="isDisable ? -1 : 0"></textarea>

</div>